import React, { createContext, useContext, useState } from 'react';

interface LayoutContextType {
  hasLayout: boolean;
  setHasLayout: (value: boolean) => void;
}

const LayoutContext = createContext<LayoutContextType | undefined>(undefined);

export const LayoutProvider: React.FC<{ children: React.ReactNode }> = ({ children }) => {
  const [hasLayout, setHasLayout] = useState(false);

  return (
    <LayoutContext.Provider value={{ hasLayout, setHasLayout }}>
      {children}
    </LayoutContext.Provider>
  );
};

export const useLayout = (): LayoutContextType => {
  const context = useContext(LayoutContext);
  if (context === undefined) {
    throw new Error('useLayout must be used within a LayoutProvider');
  }
  return context;
};
